// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Ein Layout mit diesem Namen existiert bereits`,
    ACCEPT: `Annehmen`,
    ACCEPT_ALL: `Alle akzeptieren`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Genehmigung anstehend`,
    ACCEPTED: `Angenommen`,
    ACCOUNT: `Konto`,
    ACCOUNT_ADDRESS: `Händleradresse`,
    ACCOUNT_COUNTRY: `Kontoland`,
    ACCOUNT_END: `Kontoende`,
    ACCOUNT_NAME: `Kontoname`,
    ACCOUNT_NUMBER: `Kontonummer`,
    ACCOUNT_NUMBER_REQUIRED: `Kontonummer erforderlich`,
    ACCOUNTS: `Konten`,
    ACCUMULATED_DAYS_ON_RENT: `Gesamter Mietzeitraum in Tagen`,
    ACCUMULATED_DAYS_RENTED: `Gesamter Mietzeitraum in Tagen`,
    ACTIONS: `Aktionen`,
    ACTIVE_WARRANTY: `Aktive Gewährleistung`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Aktive Gewährleistung (für Details klicken)`,
    ACTIVE_WARRANTY_Y_N: `Aktive Gewährleistung (J/N)`,
    ACTUAL_AMOUNT_OF_USE: `Tatsächlicher Nutzungsgrad`,
    ACTUAL_AUDIT: `Endgültige Prüfung`,
    ACTUAL_AUDIT_DATE: `Endgültiger Prüfungstermin`,
    ACTUAL_COURIER_NAME: `Tatsächlicher Kuriername`,
    ACTUAL_H: `Tatsächliche Stunden`,
    ACTUAL_HOURS: `Tatsächliche Stunden`,
    ACTUAL_PC:`Echte Ballen`,
    ADD_CLAIM: `Antrag hinzufügen`,
    ADD_CLAIMS: `Anträge hinzufügen`,
    ADD_COMPONENT: `Add Component`,
    ADD_OPTION: `Option hinzufügen`,
    ADD_REP: `Weitere Reparatur`,
    ADD_TO_AUDIT: `Zur Prüfung hinzufügen`,
    ADDITIONAL: `Zusätzlich`,
    ADDITIONAL_COMMENTS: `Zusätzliche Kommentare`,
    ADDITIONAL_REPAIR: `Weitere Reparatur`,
    ADDITIVE: `Zuschlag`,
    ADDRESS: `Adresse`,
    ADDRESS_LINE1: `Adresszeile 1`,
    ADDRESS_LINE1_REQUIRED: `Adresszeile 1 erforderlich`,
    ADDRESS_LINE2: `Adresszeile 2`,
    ADJ_CLM: `Berichtigung Antrag`,
    ADJUST_CLAIM: `Berichtigung Antrag`,
    ADJUSTED_HOURS: `Eingestellte Betriebsstunden`,
    ADJUSTED_QUANTITY: `Eingestellte Menge`,
    ADJUSTMENT_TYPE: `Einstelltyp`,
    ADVANCED_CLAIM_SUMMARY: `Fortgeschrittene Antragsübersicht`,
    AFTER_DELIVERY_INSPECTION: `nach Übergabeinspektion`,
    AGENCY_NAME: `Polizeibehörde`,
    ALL: `allen`,
    ALL_ACCOUNTS: `Alle Konten`,
    ALL_CLAIMS: `Alle Anträge`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Alle Erstattungsansprüche unterliegen einer Überprüfung (weitere Informationen sind dem JD-Handbuch für Gewährleistungsabwicklung 110.08 zu entnehmen).`,
    ALL_CLAIMS_TAB: `Alle Anträge ({count, number})`,
    ALL_PART_REQUESTS: `Alle Teileanforderungen`,
    ALL_PART_REQUESTS_WITH_COUNT: `Alle Teileanforderungen ({count})`,
    ALL_PARTS_RETURNED: `Alle Teile zurückgesandt`,
    AMOUNT: `Betrag`,
    AMOUNT_1: `Betrag 1`,
    AMOUNT_2: `Betrag 2`,
    AMOUNT_3: `Betrag 3`,
    AMOUNT_OF_USE: `Maschinennutzung`,
    AMOUNT_OF_USE_ACCEPETD: `Angenommene Nutzung`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Nutzung erfolgreich erstellt`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Maschinennutzung ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Nutzungswert ist erforderlich`,
    AMOUNT_OF_USE_REJECTED: `Zurückgewiesener Nutzungsbetrag`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Status der Nutzungsanforderungen`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Anzahl der Nutzungsanforderungen ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Erforderliche Nutzung`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Erforderliche Nutzungseinheiten`,
    AMOUNT_RECORDED: `Aufgezeichnete Menge`,
    AMOUNT_TO_BE_DEBITED: `Zu erhebender Betrag`,
    APLYPIP: `PIP anwenden`,
    APPLICATION: `Bearbeitung`,
    APPLICATION_IS_REQUIRED: `Anwendung ist erforderlich`,
    APPLY: `Anwenden`,
    APPLY_TRAVEL: `Reise anwenden`,
    APPROVAL_DEALER_COMMENTS: `Händlereinverständnis Kommentare`,
    APPROVAL_DETAILS: `Genehmigungsdetails`,
    APPROVAL_LEVELS: `Genehmigungsebenen`,
    APPROVAL_REMARKS: `Anmerkungen zur Genehmigung`,
    APPROVAL_STATUS: `Genehmigungsstatus`,
    APPROVE: `Genehmigen`,
    APPROVE_AMOUNT_OF_USE: `Nutzungsdauer genehmigen`,
    APPROVE_LABOR_RATE: `Lohntarif genehmigen`,
    APPROVE_MACHINE_STATUS_UPDATE: `Aktualisieren des Maschinenstatus genehmigen`,
    APPROVE_PIP_CODE_REQUEST: `PIP-Code-Antrag genehmigen`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Antrag auf Sonderentschädigung genehmigen`,
    APPROVED: `Genehmigt`,
    APPROVED_CORE_VALUE: `Genehmigter Kernwert`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `Genehmigtes Datum darf nicht vor dem Einrichtungsdatum liegen`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Genehmigter Diagnosebetrag`,
    APPROVED_DIAGNOSTIC_HOURS: `Genehmigte Diagnosestunden`,
    APPROVED_IS_REQUIRED: `Genehmigung ist erforderlich`,
    APPROVED_LABOR_ADDITIVE: `Genehmigter Zusatz für Arbeit`,
    APPROVED_LABOR_AMOUNT: `Genehmigte Arbeitsmenge`,
    APPROVED_LABOR_HOURS: `Genehmigte Arbeitsstunden`,
    APPROVED_LABOR_TOTAL: `Gesamt AZ genehmigt`,
    APPROVED_ON_SHELF_COST: `Genehmigte Lagerkosten`,
    APPROVED_OTHER_CREDITS: `Genehmigte sonstige Gutschriften`,
    APPROVED_PARTS: `Genehmigte Teile`,
    APPROVED_PARTS_ADDITIVE: `Genehmigter Zusatz für Teile`,
    APPROVED_PARTS_TOTAL: `Genehmigte Summe, Teile`,
    APPROVED_REJECTED: `Genehmigt/abgelehnt`,
    APPROVED_REPAIR_AMOUNT: `Genehmigte Reparaturbetrag`,
    APPROVED_REPAIR_HOURS: `Genehmigte Reparaturstunden`,
    APPROVED_TAXES_TOTAL: `Genehmigte Summe, Steuern`,
    APPROVED_TRAVEL_TOTAL: `Anerkannte Fahrtkosten - Gesamt`,
    APPROVER: `Genehmiger`,
    ASCENDING: `Aufsteigend`,
    ATTACHMENTS: `Anhänge`,
    AUDIT_NUMBER: `Prüfungsnummer`,
    AUDIT_PLANNED: `Prüfung geplant`,
    AUDIT_REQUIREMENT: `Prüfungsanforderung`,
    AUDIT_RESULTS: `Prüfungsergebnisse`,
    AUDIT_STATUS: `Prüfungsstatus`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Prüfung erfolgreich übertragen`,
    AUDIT_SUMMARY: `Prüfungszusammenfassung`,
    AUDIT_TYPE: `Art des Audits`,
    AUDITS: `Prüfungen`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} Prüfungen fällig`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} fällig in 30 Tagen`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} überfällig`,
    AUTHORIZATION_NUMBER: `Autorisierungsnummer`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Automatische Übertragung vom Händlersystem`,
    AVAILABLE: `Verfügbar`,
    AVAILABLE_COLUMNS: `Verfügbar Spalten`,
    AVERAGE_DIAGNOSTICS_HOURS: `Durchschnittliche Diagnosestunden`,
    AVERAGE_LUG_HEIGHT: `Durchschnittliche Führungsnockenhöhe`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `Durchschnittliche Führungsnockenhöhe ist erforderlich`,
    AVERAGE_REPAIR_HOURS: `Durchschnittliche Reparaturstunden`,
    AVERAGE_REPLACEMENT_HOURS: `Durchschnittliche Austauschstunden`,
    AVERAGE_TECH_PAY_RATE: `Durchschnittl. Tarif für techn. Arbeiten`,
    BACK: `Zurück`,
    BACK_TO_AUDIT: `Zurück zur Prüfung`,
    BASE_MACHINE: `Basismaschine`,
    BASE_MACHINE_IMPLEMENTS: `Basismaschinen-Anbaugeräte`,
    BASE_MACHINE_PIN: `Seriennummer der Basismaschine`,
    BASIC_WARRANTY_ENDS: `Basis-Gewährleistung endet`,
    BASIC_WARRANTY_ESTIMATOR: `Basis-GWL-Kalkulator`,
    BASIC_WARRANTY_STARTS: `Basis-Gewährleistung beginnt`,
    BASIS_FOR_SETTLEMENT: `Abrechnungsbasis`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Abrechnungsbasis / Prüfungkommentare`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Abrechnungsbasis ist erforderlich`,
    BATTERY: `Batterie`,
    BEGIN_DATE: `Beginndatum`,
    BRANCH: `Branch`,
    BUILT: `Baudatum`,
    BUSINESS_END: `Geschäftsergebnis`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE:`Kann die Maschine wieder eingesetzt werden?`,
    CANCEL: `Abbrechen`,
    CERTIFIED_LETTER_SENT: `Einschreiben gesendet`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Zuständigen Händler ändern`,
    CHANGE_STATUS: `Status ändern`,
    CHANGE_STATUS_FOR: `Status für {pin} ändern`,
    CHANGED: `Geändert`,
    CHANGED_BY: `Geändert von`,
    CHANGED_ON: `Geändert am`,
    CHINESE: `Chinesisch`,
    CITY: `Stadt`,
    CITY_REQUIRED: `Ort erforderlich`,
    CLAIM: `Antrag`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Antrag} other {Anträge}})`,
    CLAIM_DEBIT: `Lastschrift für Erstattungsanspruch`,
    CLAIM_DETAILS: `Einzelheiten zu den Anträgen`,
    CLAIM_DRAFT: `ENTWURF`,
    CLAIM_HISTORY: `24 Monate Antragsgeschichte`,
    CLAIM_HISTORY_WITH_COUNT: `24 Monate Antragsgeschichte ({count})`,
    CLAIM_NUMBER: `Antragsnummer`,
    CLAIM_RECOVER_PERCENTAGE: `({percentage}%)`,
    CLAIM_SEARCH: `Antragssuche`,
    CLAIM_STATUS: `Antragsstatus`,
    CLAIM_TYPE: `Antragsart`,
    CLAIM_TYPES: `Antragsarten`,
    CLAIM_UPDATED_SUCCESSFULLY: `Antrag erfolgreich aktualisiert`,
    CLAIM_VALUE: `Antragswert`,
    CLAIM_VALUE_DETAILS: `Angaben zum Antragswert`,
    CLAIM_WITH_NUMBER: `Antrag {claimNumber}`,
    CLAIMS: `Anträge`,
    CLAIMS_IN_PROGRESS: `Derzeit bearbeitete Erstattungsansprüche`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `Derzeit bearbeitete Erstattungsansprüche ({count})`,
    CLAIMS_OVERVIEW: `Überblick über die Erstattungsansprüche`,
    CLAIMS_OVERVIEW_TAB: `Überblick über die Erstattungsansprüche ({count})`,
    CLAIMS_WITH_COUNT: `{count} Anträge`,
    CLICK_FOR_DETAILS: `(Für Details klicken)`,
    CLICK_TO_VIEW_ALL: `Klicken, um alle anzuzeigen`,
    CLOSE: `Schliessen`,
    CLOSED_PART_REQUESTS: `Geschlossene Teile Anfragen`,
    CLOSING: `Schließen`,
    CLOSING_ACCOUNT: `Konto schließen`,
    CLOSING_ACCOUNT_WITH_COUNT: `Abschlusskonto ({count})`,
    CODE: `Code`,
    COLLAPSE_ALL: `Alle ausblenden`,
    COMMENT: `Kommentar`,
    COMMENTS: `Kommentare`,
    COMMENTS_IS_REQUIRED: `Kommentare sind erforderlich`,
    COMMENTS_TO_DEALER: `Kommentare für den Händler`,
    COMMON_LABOR_TYPES_WARNING: `Nicht alle für die ausgewählten Konten verfügbaren Arbeitskostentypen`,
    COMPANY: `Unternehmen`,
    COMPANY_CONTRIBUTION: `Firmenbeitrag`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Beitrag des Unternehmens ist erforderlich`,
    COMPLAINT_CAUSE: `Wie lautete die Diagnose der Beanstandung?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Beanstandungsdiagnose ist erforderlich`,
    COMPLAINT_CORRECTION: `Wie wurde die Beanstandung behoben?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `Reparatur der Beanstandung erforderlich.`,
    COMPLETE: `Abgeschlossen`,
    COMPLETED: `abgeschlossen`,
    COMPLETED_BY: `Abgeschlossen vor`,
    COMPLETED_DATE: `Fertiggestellt am`,
    COMPLETED_IN_LAST_24_MONTHS: `In den letzten 24 Monaten abgeschlossen`,
    COMPLETION_STATUS: `Abschlussstatus`,
    COMPONENT: `Komponente`,
    COMPONENT_CODE: `Component Code`,
    COMPONENT_CREATED_SUCCESSFULLY: `Component Created Successfully`,
    COMPONENT_DELETED_SUCCESSFULLY: `Component Deleted Successfully`,
    COMPONENT_SERIAL_NUMBER: `Komponentenseriennummer`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Komponente erfolgreich aktualisiert`,
    COMPONENTS: `Komponenten`,
    CONFIRM: `Bestätigen`,
    CONFIRM_ADDITIONAL_REPAIR: `Sind Sie sicher, dass Sie weitere Reparaturen hinzufügen möchten?`,
    CONFIRM_ADJUST_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag anpassen möchten?`,
    CONFIRM_CLOSING_ACCOUNT: `Sind Sie sicher, dass Sie diese Übertragung annehmen möchten?`,
    CONFIRM_COPY_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag kopieren möchten?`,
    CONFIRM_DELETE_ATTACHMENT: `Möchten Sie die angehängte Datei wirklich löschen?`,
    CONFIRM_DELETE_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag löschen möchten?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Sind Sie sicher, dass Sie diese Maschinenstatusanforderung löschen möchten?`,
    CONFIRM_DELETE_REGISTRATION: `Sind Sie sicher, dass Sie diese Registrierung löschen möchten?`,
    CONFIRM_EDIT_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag wirklich bearbeiten?`,
    CONFIRM_RECONCILE_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag abstimmen möchten?`,
    CONFIRM_RESEND_XML: `Sind Sie sicher, dass Sie erneut XML einsenden möchten? Bitte geben Sie 24-48 Stunden Zeit, um es zu sehen.`,
    CONFIRM_SKIP_AUDIT: `Sind Sie sicher, dass Sie möchten die Prüfung überspringen?`,
    CONFIRM_UNDO_REGISTRATION: `Sind Sie sicher, dass Sie diese Registrierung rückgängig machen möchten?`,
    CONFIRM_UNRECONCILE_CLAIM: `Sind Sie sicher, dass Sie diesen Antrag abstimmen möchten?`,
    CONNECTED_MACHINE: `vernetzte Maschine`,
    CONTACTED: `Kontaktiert`,
    CONTAINS: `enthält`,
    CONTRACT_NUMBER: `Vertragsnummer`,
    CONTRACT_PURCHASED: `Vertrag zu Verkäufen`,
    CONTRACT_TYPE: `Vertragsart`,
    COPY_CLAIM: `Antrag kopieren`,
    CORE: `Kern`,
    CORE_VALUE: `Altteil Wert`,
    COUNTRY: `Land`,
    COUNTRY_REQUIRED: `Land erforderlich`,
    COURIER_ACCOUNT_NUMBER: `Kurierkontonummer`,
    COURIER_NAME: `Logistikfirma`,
    COVERAGE_DECISION: `Bedeckungsentscheidung`,
    COVERAGE_TYPE: `Bedeckungstyp`,
    CRDMEM: `Gutschrift`,
    CREATE: `Anlegen`,
    CREATE_CLAIM: `Antrag anlegen`,
    CREATE_LAYOUT: `Anlegen Layout`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Bevor Sie einen Antrag für dieses Projekt stellen können, benötigen wir noch einige wichtige Angaben von Ihnen.`,
    CREATE_PIP_CLAIM: `PIP-Antrag erstellen`,
    CREATE_PIP_CLAIMS: `PIP-Anträge erstellen`,
    CREATE_PRODUCT_RECORD: `Produktdatensatz erstellen`,
    CREATE_REQUEST: `Anforderung erstellen`,
    CREATE_TRANSFER_PENDING: `Übertragung anstehend`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Umlagerungsservice erstellen nicht verfügbar`,
    CREATED: `Erstellt`,
    CREATED_BY: `Erstellt von`,
    CREATED_DATE: `Erstellt am`,
    CREATED_DATE_FROM: `Von Erstellungsdatum`,
    CREATED_DATE_TO: `Bis Erstellungsdatum`,
    CREATED_ON: `Erstellt am`,
    CREATION_DATE: `Erstellungsdatum`,
    CREDIT_MEMO: `Gutschrift`,
    CREDIT_MEMO_DATE: `Gutschriftdatum`,
    CREDIT_MEMO_ISSUE_DATE: `Gutschrift ausgegeben`,
    CREDIT_MEMO_NUMBER: `Gutschriftnummer`,
    CREDIT_MEMO_PROCESS_DATE: `Gutschrift verarbeitet`,
    CREDIT_MEMO_SELECTED: `Ausgewählte Gutschrift`,
    CREDIT_MEMOS: `Gutschriften`,
    CRITERIA: `Kriterien`,
    CRT: `Anlegen`,
    CSV_SEPARATOR: `CSV-Separator`,
    CURRENCY: `Währung`,
    CURRENT: `Aktuell`,
    CURRENT_ACCOUNT: `Aktuelles Konto`,
    CURRENT_AMOUNT_OF_USE: `Aktuelle Maschinennutzung`,
    CURRENT_CUSTOMER: `Aktueller Kunde`,
    CURRENT_DEALER: `Derzeitiger Händler`,
    CURRENT_DEALER_DISTANCE: `Aktuelle Händlerstrecke`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Letztes Wartungsdatum des Vertriebspartners`,
    CURRENT_DEALER_LOCATION: `Aktueller Händlerstandort`,
    CURRENT_HOURS: `Aktuelle Betriebsstunden`,
    CURRENT_QUANTITY: `Aktuelle Menge`,
    CURRENT_RESPONSIBLE_DEALER: `Derzeitiger verantwortlicher Vertriebspartner`,
    CURRENT_VALUES: `Aktuelle Werte`,
    CURRENTLY_ON_RENT: `Aktuell gemietet`,
    CUSTOM_RANGE: `Benutzerspezifischer Bereich`,
    CUSTOM_VALUES: `Angepasste Werte`,
    CUSTOMER: `Kunde`,
    CUSTOMER_CONTRIBUTION: `Kundenbeitrag`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Kundenbeitrag ist erforderlich`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Kunde erfolgreich erstellt`,
    CUSTOMER_DETAILS: `Kundenprofil`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Kundendaten erfolgreich aktualisiert`,
    CUSTOMER_INFORMATION: `Kundeninformation`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Kundeninformationen sind erforderlich.`,
    CUSTOMER_INVALID: `Kunde ungültig`,
    CUSTOMER_NAME: `Kundenname`,
    CUSTOMER_NAME_IS_REQUIRED: `Kundeninformationen sind erforderlich.`,
    CUSTOMER_NOT_FOUND: `Kunde nicht gefunden`,
    CUSTOMER_PROFILE: `Kunden-Profil`,
    CUSTOMER_REQUIRED: `Kunde erforderlich`,
    CUSTOMER_RESOLUTION: `Kundenlösung`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Kundenlösung ist erforderlich`,
    CUSTOMER_SEARCH: `Kundensuche`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Kunde erfolgreich aktualisiert`,
    DAMAGED_MACHINES_HELP_TEXT:`Für beschädigte Maschinen wird die Garantie automatisch ausgesetzt, bis dieses Formular vom Territory Customer Support Manager (TCSM) zur Aufhebung der Aussetzung der Garantie geprüft und genehmigt wurde. Beschädigte Maschinen kommen nur für Vorgeschrieben und Sicherheits-PIPs infrage.`,
    DATE: `Datum`,
    DATE_FORMAT: `Datumsformat`,
    DATE_ISSUED: `Erstellungsdatum`,
    DATE_OF_CERTIFIED_LETTER: `Datum des Einschreibens`,
    DATE_OF_EVENT_CAUSING_DAMAGE:`Datum des Ereignisses, das den Schaden verursacht hat`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Datum des letzten persönlichen Kontakts`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Versanddatum des rücksendepflichtigen Teils`,
    DATE_REFUSED: `Datum abgelehnt`,
    DATE_SUBMITTED: `Datum der Übermittlung`,
    DAYS_FROM_REGISTRATION: `Tage seit der Registrierung`,
    DAYS_LEFT: `Tage Rest`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} {days, plural, one {Tag} other {Tage}} Rest`,
    DAYS_ON_RENT: `Vermietete Tage`,
    DAYS_REMAINING: `Restliche Tage`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {Tag} other {Tage}} Verbleibend`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {Tag} other {Tage}} Seit Empfehlung`,
    DAYS_TO_DISPLAY: `Anzuzeigende Tage`,
    DBS: `DBS`,
    DEALER: `Händler`,
    DEALER_ACCOUNT: `Händlerkonto`,
    DEALER_ACCOUNT_IS_REQUIRED: `Händlerkonto ist erforderlich`,
    DEALER_ACCOUNTS: `Händlerkonten`,
    DEALER_CITY: `Händler Stadt`,
    DEALER_COMMENTS: `Händlerkommentare`,
    DEALER_CONTRIBUTION: `Händlerbeitrag`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Händlerbeitrag ist erforderlich`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Vertriebspartnerrechnungsnr.`,
    DEALER_INVOICE_UPDATED: `Händlerrechnung aktualisiert`,
    DEALER_INVOICE_UPDATES: `Händlerrechnung`,
    DEALER_INVOICES: `Händlerrechnungen`,
    DEALER_LOCATION: `Adresse des Vertriebspartners`,
    DEALER_LOCATION_FILTER: `Filterorte`,
    DEALER_LOCATION_IS_REQUIRED: `Händlerstandort erforderlich`,
    DEALER_LOCATIONS: `Händlerstandorte`,
    DEALER_NAME: `Händler Name`,
    DEALER_PHONE: `Telefonnummer des Vertriebspartners`,
    DEALER_POSTAL_CODE: `Postleitzahl`,
    DEALER_RECOMMENDATIONS: `Händlerempfehlungen`,
    DEALER_RECOMMENDATIONS_TAB: `Empfehlungen für Vertriebspartner ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Vertriebspartner erfolgreich überprüft`,
    DEALER_SEARCH: `Händlersuche`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Name, Stadt oder Konto eingeben, um nach Händlern zu suchen`,
    DEALER_STATE: `Standort des Vetriebspartners (Stadt/Bundesland/PLZ)`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Händlerübermittlung ({currency})`,
    DEALER_TRANSFER_HISTORY: `Historie der Händlerübernahmen`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Einige Übertragungsanfragen wurden erfolgreich erstellt. Prozess bleibt einzeln.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Anfrage Händlerübertragung erfolgreich eingereiht`,
    DEALER_WARRANTY: `Händlergewährleistung`,
    DEALERS: `Händler`,
    DEALERSHIP: `Vertragshändler`,
    DEBIT: `Lastschrift`,
    DEBIT_AMOUNT: `Lastschriftbetrag`,
    DEBIT_FOR_CLAIM_NUMBER: `Lastschrift für {claimNumber}`,
    DEBIT_REQUIRED: `Lastschrift erforderlich`,
    DEBIT_REQUIRED_STATUS: `Status Lastschrift erforderlich`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Lastschrift erfolgreich eingereicht`,
    DEBIT_TYPE: `Art der Lastschrift`,
    DEBITED: `Lastschrift`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Lastschriften für diesen Antrag müssen über den manuellen Lastschriftenprozess erfolgen`,
    DECIMAL_FORMAT: `Dezimalformat`,
    DECISION_UPDATED: `Entscheidung aktualisiert`,
    DECLINE: `Ablehnen`,
    DEDUCTIBLE: `Selbstbeteiligung`,
    DEERE_REMARKS: `John Deere Bemerkungen`,
    DEFAULT_WARRANTY: `Vorgabe-GWL`,
    DEL: `Löschen`,
    DELETE: `Löschen`,
    DELETE_ATTACHMENT: `Anbaugerät löschen`,
    DELETE_CLAIM: `Antrag löschen`,
    DELETE_MACHINE_STATUS_UPDATE: `Aktualisierung des Maschinenstatus löschen`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Löschen des Maschinenstatus erfolgreich`,
    DELETE_REGISTRATION: `Registrierung löschen`,
    DELETE_REGISTRATION_SUCCESS: `Registrierung erfolgreich gelöscht`,
    DELETED: `Gelöscht`,
    DELETED_BY: `Gelöscht durch`,
    DELIVERED: `Geliefert`,
    DELIVERED_IS_REQUIRED: `Geliefert ist erforderlich`,
    DELIVERY_DATE: `Auslieferungsdatum`,
    DELIVERY_DATE_REQUIRED: `Übergabedatum notwendig.`,
    DELIVERY_DATES: `Liefertermine`,
    DELIVERY_NO_DOCUMENTS: `Lieferung ohne Dokumente`,
    DEMO_RENTAL_BEGIN_DATE: `Demo/Miete Anfangsdatum`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Händler und Status auswählen`,
    DEMO_RENTAL_END_DATE: `Demo/Miete Enddatum`,
    DEMO_RENTAL_HISTORY: `Miet-/Demoverlauf`,
    DENY: `Ablehnen`,
    DENY_AMOUNT_OF_USE: `Nutzungsdauer verweigern`,
    DENY_MACHINE_STATUS_UPDATE: `Aktualisieren des Maschinenstatus ablehnen`,
    DENY_PIP_CODE_REQUEST: `PIP-Code-Antrag ablehnen`,
    DESCENDING: `Absteigend`,
    DESCRIPTION: `Beschreibung`,
    DESCRIPTION_OF_DAMAGE:`Beschreibung des Schadens`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE:`Beschreibung des Ereignisses, das den Schaden verursacht hat`,
    DESELECT_ALL: `Auswahl für alle aufheben`,
    DETAILS: `Details`,
    DIAGNOSTICS_COVERED: `Abgedeckte Diagnosen`,
    DIS_VSR: `Meldungen anzeigen`,
    DISPLAY: `Anzeigen`,
    DISPLAY_CLAIM: `Antrag anzeigen`,
    DISPLAY_CREDIT_MEMO: `Gutschrift anzeigen`,
    DISPLAY_FORMAT: `Anzeigeformat`,
    DISPLAY_PRODUCT: `Produkt anzeigen`,
    DISPLAY_TAG: `Kennzeichnung anzeigen`,
    DISTANCE: `Entfernung`,
    DISTANCE_FROM_CURRENT_DEALER: `Abstand zum aktuellen Vertriebspartner`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Abstand zum potenziellen Vertriebspartner`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Entfernung vom zuständigen Konto`,
    DIVISION: `Gruppe`,
    DIVISION_SUMMARY: `Zusammenfassung Unternehmensbereich`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Möchten Sie Ihre Änderungen speichern?`,
    DOES_NOT_CONTAIN: `beinhaltet nicht`,
    DOWNLOAD_TO_EXCEL: `In Excel herunterladen`,
    DOWNTIME: `Ausfallzeit`,
    DOWNTIME_IS_REQUIRED: `Standzeit muss angegeben werden`,
    DRAFT: `Als Entwurf speichern`,
    DTAC_CASE: `DTAC-Fallnummer`,
    DTAC_CASE_NUMBER: `DTAC-Bearbeitungsnummer`,
    DTAC_SOLUTION: `DTAC-Lösung`,
    DUE_DATE: `Fälligkeitsdatum`,
    DUE_WITHIN_3_MONTHS: `Fällig innerhalb der nächsten 3Monate`,
    DUPLICATE_PIN_PLATE: `Doppeltes PIN-Schild`,
    DUPLICATE_PIN_PLATE_REPORT: `Bericht über doppeltes PIN-Schild`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Anforderung für doppeltes PIN-Schild aktualisiert`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Anforderung für doppeltes PIN-Schild erfolgreich erstellt`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Anforderung doppeltes PIN-Schild ({count})`,
    EDIT: `Bearbeiten`,
    EDIT_CUSTOMER: `Kunde bearbeiten`,
    EDIT_LAYOUT: `Bearbeiten Layout`,
    EDIT_WITH_PARENTHESES: `(Bearbeiten)`,
    EFFECTIVE: `Mit Wirkung ab`,
    EFFECTIVE_DATE: `Gültig ab`,
    EMAIL: `Email`,
    EMISSIONS_PART_SEARCH: `Suche nach Emissionsteilen`,
    END_DATE: `Enddatum`,
    END_USE: `Endbenutzer-Code`,
    END_USE_CODE: `Endbenutzer-Code`,
    END_USE_CODE_REQUIRED: `Endverwendungscode erforderlich`,
    ENDS_WITH: `endet mit`,
    ENGLISH: `Englisch`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `Eine Zahl zwischen 0 und 1000 eingeben`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `Eine Zahl zwischen 0 und 10.000 eingeben`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `Eine Zahl zwischen 1 und 9999 eingeben`,
    ENTER_A_PART_NUMBER: `Teilenummer eingeben`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Kommentare vor Annahme eingeben`,
    ENTITY_ID: `Entität ID`,
    EQUALS: `gleich`,
    ERROR: `Fehler:`,
    ERROR_MESSAGE_TITLE: `Ein Fehler ist aufgetreten:`,
    ERROR_MESSAGES: `Fehlermeldungen`,
    ERROR_MESSAGES_TITLE: `Mehrere Fehler sind aufgetreten:`,
    ERROR_NETWORK_ISSUES: `Aufgrund eines Netzwerkfehlers konnten einige Daten nicht geladen werden – bitte versuchen Sie es erneut`,
    ERROR_NO_DATA_TO_EXPORT: `Keine Daten zum Export`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Fehlersuche bei Kundeninformationen`,
    ERROR_SAP: `Verbindung zu Server nicht möglich. Wenn das Problem bestehen bleibt, klicken Sie auf den Link "Kontakt", um sich Unterstützung bei der Lösung Ihres Problems zu sichern.`,
    ERROR_SESSION: `Ihre Sitzung ist abgelaufen. Aktualisieren Sie die Seite, bevor Sie sich erneut anmelden.`,
    ERROR_UNHANDLED: `Im System ist ein unerwarteter Fehler aufgetreten. Wenn das Problem anhält, nutzen Sie bitte unsere Funktion "Hilfe" oder klicken Sie auf "Kontakt", um sich Unterstützung bei der Lösung Ihres Problems zu sichern.`,
    ERROR_UPLOADING_FILE: `Datei wurde nicht hinzugefügt`,
    ESTIMATED_BASIC_DATE: `Geschätztes Basisdatum`,
    ESTIMATED_BASIC_DAYS: `Geschätzte Basistage`,
    ESTIMATED_HOURS: `Geschätzte Betriebsstunden`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Schätzungen entsprechen möglicherweise nicht dem Demostatus oder den noch nicht gemeldeten Stunden`,
    EXCEEDS_DEMO_THRESHOLD: `Überschreitet Demoschwelle`,
    EXCHANGE_RATE: `Kurs`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Ausgeschlossene PINs sind nicht in diesem Bericht enthalten.`,
    EXECUTE: `Anwenden`,
    EXPAND_ALL: `Alle erweitern`,
    EXPECTED_FIRST_USE: `Voraussichtliche erste Nutzung`,
    EXPIRATION_DATE: `Ablaufdatum`,
    EXPIRED: `Abgelaufen`,
    EXPIRED_PART_REQUESTS: `Abgelaufene Teileanforderungen`,
    EXPIRED_PIPS: `Abgelaufene Programme`,
    EXPIRES: `Läuft ab`,
    EXPIRING_SOON: `Läuft in Kürze ab`,
    EXPORT: `Exportieren`,
    EXTENDED_WARRANTY: `Erweiterte Garantie`,
    FACTORY: `Werk`,
    FACTORY_DUPLICATE_PIN_PLATE: `Doppeltes PIN-Schild`,
    FACTORY_NAME: `Werksname`,
    FACTORY_USERS_TAB: `Doppeltes PIN-Schild ({count})`,
    FAILED: `Ausfalldatum`,
    FAILED_AREA: `Schadhafte Baugru`,
    FAILED_AREA_IS_REQUIRED: `Fehlerbereich ist erforderlich`,
    FAILED_DATE: `Datum des Fehlschlags`,
    FAILED_DATE_IS_REQUIRED: `Datum des Fehlschlags ist erforderlich`,
    FAILED_MODE: `Schadensart`,
    FAILED_MODE_COMMENTS: `Kommentare zu Fehlermodus`,
    FAILED_PART: `Schadensteilenummer`,
    FAILED_PART_DESCRIPTION: `Beschreibung des defekten Teils`,
    FAILED_PART_IS_A_REMAN_PART: `Schadensteilenummer ist ein ReMan Artikelnummer`,
    FAILED_PART_IS_REQUIRED: `Defektes Teil ist erforderlich`,
    FAILED_PART_SERIAL: `Seriennummer des defekten Teils`,
    FAILED_PART_SERIAL_IS_REQUIRED: `Seriennummer des defekten Teils ist erforderlich`,
    FAILURE_DATE: `Ausfalldatum`,
    FAILURE_INFORMATION: `Schadensinformation`,
    FAILURE_MODE: `Schadensart`,
    FAILURE_MODE_IS_REQUIRED: `Fehlermodus ist erforderlich`,
    FAILURE_PART: `Schadensteilenummer`,
    FAILURE_PART_DESCRIPTION: `Schadenverursachende Teilebeschreibung`,
    FAILURE_PART_IS_REQUIRED: `Schadensteilenummer ist erforderlich`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Wenn Sie die angeforderten Teile nicht zurücksenden, kann dies zu einer Belastung führen.`,
    FAVORITES: `Favoriten`,
    FILE_NAME: `Dateiname`,
    FILE_SIZE_IS_TOO_BIG: `Dateigröße überschritten (Maximale Größe: 100 MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `Dateigröße überschritten (Maximale Größe: 1 MB)`,
    FILE_UPLOAD_MESSAGE: `Daten hier ablegen oder zum Hinzufügen von Dateien klicken (Maximale Größe: 100 MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `Daten hier ablegen oder zum Hinzufügen von Dateien klicken (Maximale Größe: 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Bilder hier ablegen oder zum Hinzufügen von Bilder klicken (Maximale Größe: 100 MB)`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Eine einzelne Datei hier ablegen oder hier klicken, um die Datei hinzuzufügen (Maximale Größe: 100 MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Das System konnte Ihre Datei nicht lesen.  Bitte vergleichen Sie es mit der Vorlage und versuchen Sie es erneut.`,
    FILES: `Dateien`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Keine Ergebnisse. Eingabetaste drücken, um alle Empfehlungen zu durchsuchen.`,
    FILTER_PLACEHOLDER: `Filterergebnisse`,
    FILTER_WITH_ELLIPSIS: `Filtern...`,
    FILTERED_BY_COLUMN_ID: `Gefiltert nach {columnId}`,
    FIND_CUSTOMER: `Finden Sie Kunde`,
    FINNISH: `Finnisch`,
    FIRST_MAINTENANCE: `ERSTE WARTUNG`,
    FIRST_NAME: `Vorname`,
    FIRST_NAME_IS_REQUIRED: `Vorname ist erforderlich`,
    FIRST_SHIP_TO_LOCATION: `Erste Lieferung zum Standort`,
    FIRST_USE: `Voraussichtlicher Ersteinsatz`,
    FISCAL_YEAR: `Geschäftsjahr`,
    FLUID_SAMPLING_REQUIRED: `Flüssigkeitsprobe erforderlich`,
    FORWARDED: `Weitergeleitet`,
    FRENCH: `Französisch`,
    FROM: `von`,
    FRWRD: `Weiterleiten`,
    FULL_DEBIT: `Vollständige Lastschrift`,
    GENERAL: `Allgemein`,
    GERMAN: `Deutsche`,
    GET_MAINTENANCE_PLANS: `Wartungspläne abrufen`,
    GOODS_INSTALLATION_VAT: `Wareninstallation MwSt.`,
    GRACE_PERIOD: `Karenzzeit`,
    GREATER_THAN: `größer`,
    GREATER_THAN_OR_EQUALS: `größer gleich`,
    GROUP_COMPLETE: `Gruppe abgeschlossen`,
    GST_PERCENTAGE: `GST Prozente`,
    H_LIMIT: `Stundenbegrenzung`,
    HISTORY_TO_DISPLAY: `Maschinengeschichte anzeigen`,
    HOME: `Privat`,
    HOUR_LIMIT: `Stundenbegrenzung`,
    HOURS: `Stunden`,
    HOURS_ON_RENT: `Stunden gemietet`,
    HSN_SAC_CODE: `HSN/SAC Code`,
    IGST: `IGST`,
    IMPLEMENTS: `Anbaugeräte`,
    IN_RANGE: `im bereich`,
    INCENTIVE: `Anreiz`,
    INCENTIVE_PROGRAMS: `Anreizprogramme`,
    INCLUDE_FULLY_COMPLETE: `Vollständige PIPs einschließen`,
    INDICATES_REQUIRED_FIELD: `Zeigt Pflichtfeld an`,
    INFO_MESSAGE_TITLE: `Eine System-Benachrichtigung wurde gesendet:`,
    INFO_MESSAGES: `Info-Meldungen`,
    INFO_MESSAGES_TITLE: `Mehrere System-Benachrichtigungen wurden gesendet`,
    INFO_REQUEST_STATUS_ERRORS: `Die Informationen können mit dieser Anfrage gesendet werden.`,
    INFORMATION: `Information`,
    INFORMATION_REQUEST: `Informationsanfrage`,
    INFORMATION_REQUEST_STATUS: `Status der Informationsanforderung`,
    INPUT_PIN: `Eingangs-PIN`,
    INSPECTION: `Inspektion`,
    INSTALLED_BY: `Eingebaut durch`,
    INSTALLED_BY_IS_REQUIRED: `Eingebaut durch ist erforderlich`,
    INTERNAL_DEERE_COMMENTS: `Interne Deere Kommentare`,
    INTERNAL_EQUIPMENT_NOTES: `Interne Ausrüstungsnotizen`,
    INTERVAL_BEGINS: `Intervall beginnt`,
    INTERVAL_ENDS: `Intervall endet`,
    INTERVAL_TYPE_DESCRIPTION: `Beschreibung des Intervalltyps`,
    INVOICE_ACCOUNT: `Rechnungskonto`,
    INVOICE_DEALER: `Händlerrechnung`,
    INVOICE_NUMBER: `Rechnungsnummer`,
    INVOICE_REQUEST: `Rechnungsanforderung`,
    INVOICE_SENT: `Rechnung gesendet`,
    INVOICE_UPDATED_SUCCESSFULLY: `Rechnung erfolgreich aktualisiert`,
    INVOICED: `Rechnungsdatum`,
    INVOICED_TO: `Fakturiert an`,
    IRC_PIN_MESSAGE: `Der Kunde ist ein IRC und hat Anspruch auf kostenlose Fahrtzeit und Fahrtstrecke während der ersten 500 Betriebsstunden oder 12 Monate des Maschineneigentums.`,
    ISSUED: `Ausgegeben`,
    ITALIAN: `Italienisch`,
    ITEM: `Position`,
    ITEM_NUMBER: `Positionsnummer`,
    ITEM_NUMBER_IS_REQUIRED: `Artikelnummer ist erforderlich`,
    JDLINK_EXPIRES: `JDLink läuft ab`,
    JDP_COMMENTS: `Kommentar`,
    JDP_COMMENTS_IS_REQUIRED: `JDP-Bemerkungen sind erforderlich`,
    JDP_CUSTOMER_RESOLUTION: `Händlerlösung`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `JDP-Kundenlösung ist erforderlich`,
    JDP_REASON: `Begründung`,
    JDP_REASON_IS_REQUIRED: `JDP-Grund ist erforderlich`,
    LABOR: `Anwenden`,
    LABOR_ADDITIVE: `Lohnzuschlag`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `Ausführungsquote Abschluss – Details`,
    LABOR_ADDITIVE_PIPS: `Arbeitszeitzuschlag-PIPs`,
    LABOR_ADDITIVE_TAB: `Ausführungsquote ({count})`,
    LABOR_ADJUSTMENT: `Arbeitszeiteinstellung`,
    LABOR_COMMENTS: `Aufwandkommentare`,
    LABOR_HOURS: `Aufwand`,
    LABOR_ITEM_DETAILS: `Arbeit – {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `Lohntarif erfolgreich genehmigt`,
    LABOR_RATE_CHANGE_SUBMITTED: `Lohntarifänderung übermittelt`,
    LABOR_RATE_CHANGES_WITH_COUNT: `Lohntarifänderungen ({count})`,
    LABOR_RATE_CONFIRM: `Der angeforderte Lohntarif liegt unter dem aktuellen Tarif. Sind Sie sicher, dass Sie die Anfrage senden wollen?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Die Raten im roten Text weisen auf einen Anstieg um mehr als 10 % gegenüber dem bestehenden Satz hin`,
    LABOR_RATE_HISTORY: `Lohntarifverlauf`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `Lohntarif erfolgreich abgelehnt`,
    LABOR_RATE_REQUESTS_STATUS: `Status der Arbeitskostensatzanträge`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `Arbeitskostensatz erfolgreich zurückgesendet`,
    LABOR_RATES: `Stundensätze`,
    LABOR_STATS: `Arbeitsstatistik`,
    LABOR_TOTAL: `Gesamt Arbeit`,
    LABOR_TYPE: `Aufwandsart`,
    LABOR_VALUE: `AZ Wert`,
    LABOR_WITH_COUNT: `Ausführung ({count})`,
    LANGUAGE: `Sprache`,
    LAST_LOCATION_FROM: `Letzte Stelle von`,
    LAST_NAME: `Nachname`,
    LAST_NAME_IS_REQUIRED: `Familienname ist erforderlich`,
    LAST_PERSONAL_CONTACT: `Letzter persönlicher Kontakt`,
    LAST_SEEN: `Zuletzt gesehen`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Letzter Blick auf das verantwortliche Konto`,
    LATEST: `Neueste`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Angaben der Strafverfolgungsbehörde`,
    LAYOUT_CREATED_SUCCESSFULLY: `Layout erfolgreich erstellt`,
    LAYOUT_DELETED_SUCCESSFULLY: `Layout erfolgreich gelöscht`,
    LAYOUT_NAME: `Name des Layouts`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Layout wurde erfolgreich aktualisiert`,
    LEAD_ACCOUNT: `Übergeordnete Firma`,
    LEAD_DEALER: `Lead-Händler`,
    LESS_THAN: `kleiner`,
    LESS_THAN_OR_EQUALS: `kleiner gleich`,
    LICENSE_PLATE_NUMBER: `Kfz-Kennzeichen`,
    LIFETIME: `Lebenszeitgarantie`,
    LINE_ITEMS_EXPORT: `Einzelpostenexport`,
    LIST: `Liste`,
    LIST_TOTAL: `Liste Gesamt`,
    LOCATION: `Standort`,
    LOCATION_DUE: `Standort fällig`,
    LOCATIONS: `Standorte`,
    LOCATIONS_WITH_COUNT: `Standorte ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `Maschine ist bereits unter diesem Kunden registriert`,
    MACHINE_INFORMATION: `Maschineninformation`,
    MACHINE_MODEL_TYPE: `Maschinenmodell/Maschinentyp`,
    MACHINE_MODEL_TYPE_REQUIRED: `Maschinenmodell/Typ erforderlich`,
    MACHINE_STATUS: `Maschinenstatus`,
    MACHINE_STATUS_UPDATE: `Maschinenstatus aktualisiert`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Aktualisierung des Maschinenstatus genehmigt`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Dokument zum Aktualisieren des Maschinenstatus`,
    MACHINE_STATUS_UPDATE_REJECTED: `Aktualisieren des Maschinenstatus abgelehnt`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Aktualisierungen des Maschinenstatus ({count})`,
    MACHINE_TYPE: `Maschinentyp`,
    MACHINE_TYPE_IS_REQUIRED: `Maschinentyp ist erforderlich`,
    MACHINE_USE: `Maschinennutzung`,
    MAILING_RECIPIENT: `Empfänger der E-Mail (Vor- und Nachname)`,
    MAILING_RECIPIENT_REQUIRED: `Empfänger der Postsendung erforderlich`,
    MAINTENANCE: `Instandhaltung`,
    MAINTENANCE_PLAN: `Wartungspläne`,
    MAINTENANCE_PLAN_INFO: `Wartungsplaninformationen`,
    MARK_AS_INPROCESS: `Als "In Bearbeitung" markieren`,
    MARK_AS_REVIEW: `Markierung wie besprochen`,
    MARKETING_INCENTIVE: `Marketing - Anreiz`,
    MARKETING_JD_PROMISE: `Marketing – JD-Versprechen`,
    MARKETING_MAINTENANCE_PLAN: `Marketing – Wartungsplan`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Marketing – Handelskette Weiterverfolgung`,
    MARKETING_MASS_CHANNEL_PDI: `Marketing – Handelskette Übergabeinspektion`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Kontaktaufnahme mit Handelsketten-Kunden`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Erinnerung: Denken Sie daran, Ihren Legal Counsel zu kontaktieren, um die geeigneten #Do Not Call#-Verfahren in Ihrem Bundesland/Bundesstaat und auf Bundesebene festzustellen, ehe Sie Ihr Programm zur Nachverfolgung nach dem Verkaufsgespräch (Follow-up After the Sale Call Program) umsetzen.`,
    MASS_CHANNEL_PDI_CLAIM: `Handelskette Übergabeinspektion`,
    MASTER_WARRANTY_TYPE: `Hauptgewährleistungstyp`,
    MATERIAL:`Materialnummer`,
    MERCHANDISE: `Werbeartikel`,
    MESSAGE: `Nachricht`,
    MESSAGES: `Meldungen`,
    METHOD_OF_CONTACT: `Methode der Kontaktaufnahme`,
    METHOD_OF_CONTACT_IS_REQUIRED: `Kontaktmethode ist erforderlich`,
    METRIC: `Metrisch`,
    METRICS: `Metriken`,
    MILEAGE_LIMIT: `Kilometerbegrenzung`,
    MOBILE_PHONE: `Mobiltelefon`,
    MODEL: `Modell`,
    MODEL_NUMBER: `Modellnummer`,
    MODEL_YEAR: `Modelljahr`,
    MODIFIED: `Geändert`,
    MONTH_TO_DATE: `Aktueller Monat`,
    MORE: `Mehr`,
    MULTIPLE: `Mehrere`,
    NAME: `Name`,
    NET: `Netto`,
    NET_AMOUNT: `Nettobetrag`,
    NET_AMOUNT_PAID: `Nettobetrag gezahlt`,
    NET_TOTAL: `Nettogesamt`,
    NEW: `Neu`,
    NEW_ACCOUNT: `Neues Konto`,
    NEW_CLAIM: `Neuer Antrag`,
    NEW_CLAIM_VALUE: `Neuer Anspruchswert`,
    NEW_CUSTOMER_REQUIRED: `Neuer Kunde erforderlich`,
    NEW_DEALER: `Neuer Händler`,
    NEW_DEALER_DISTANCE: `Abstand des neuen Händlers`,
    NEW_DEALER_LOCATION: `Neuer Händlerstandort`,
    NEW_LABOR_RATE: `Neuer Lohntarif`,
    NEW_REQUEST_ENTER_RATES: `Neue Anforderung - Raten eingeben`,
    NEW_STATUS: `Neuer Status`,
    NEW_TRANSFER: `Neue Umlagerung`,
    NEW_TRANSFER_CREATED: `Neue Umlagerung erstellt`,
    NEW_VALUE: `Neuer Wert`,
    NO: `Nein`,
    NO_ACTIVE_WARRANTY: `Keine aktive Gewährleistung`,
    NO_AFFECTED_PINS: `In der Zuständigkeit Ihres Händlerbetriebs gibt es keine betroffenen PINs`,
    NO_AUTHORITY_TO_ACCESS: `Sie haben keine Berechtigung, auf die JDWS zuzugreifen. Händlerbenutzer wenden Sie sich bitte an Ihren Profiladministrator (DPA), um die Autorität zu überprüfen und sich mit dem Support in Verbindung zu setzen, wenn Sie eine Kopie dieses Fehlers erhalten`,
    NO_CLAIMS: `Es liegen keine Anträge vor.`,
    NO_CUSTOMER_ASSOCIATED: `Kein zugehöriger Kunde`,
    NO_CUSTOMER_SELECTED: `Kein Kunde ausgewählt`,
    NO_DEALER_INVOICES: `Keine Händlerrechnungen`,
    NO_DEALERS_MAPPED: `Ihrer Benutzer-ID sind keine Vertriebspartner zugeordnet. Wenden Sie sich an Ihren Systemadministrator.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE:`Nein (In diesem Fall muss ein Bild als Nachweis beigelegt werden.)`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `No information available for this product`,
    NO_LABOR_COVERAGE: `Keine Deckung durch Arbeitskräfte`,
    NO_LOWERCASE: `Nr.`,
    NO_MATCHING_DEALERS: `Kein Händler passend zum Filtertext.`,
    NO_OPEN_PART_REQUESTS: `Keine offenen Teileanforderungen`,
    NO_OPEN_PIPS: `Keine offenen PIPs`,
    NO_PARTS_RETURNED: `Keine Teile zurückgesandt`,
    NO_PIP_PRODUCTS: `Es liegen keine PIP-Produkte vor.`,
    NO_PRODUCT_FOUND: `Keine Produkt gefunden`,
    NO_REQUIRED_ITEMS: `Keine erforderlichen Posten.`,
    NO_RESULTS: `Keine Ergebnisse`,
    NO_RESULTS_FOUND: `Keine Ergebnisse gefunden`,
    NO_ROWS_TO_SHOW: `Keine Reihen anzuzeigen`,
    NO_SPECIAL_INSTRUCTIONS: `Keine besonderen Anweisungen.`,
    NO_TRAVEL: `Keine Fahrt`,
    NON_RECOVERABLE_TAXES: `Nicht erstattungsfähige Steuern`,
    NON_TRACKED_PINS_HELP_TEXT: `Einige Produkte werden erst nach der Registrierung in „Garantie“ angezeigt. Bei Ihrer Suche ergeben sich Übereinstimmungen mit mehreren dieser Produkte.`,
    NON_TRAVEL: `Non-Travel`,
    NONE: `Keine`,
    NORMAL: `NORMAL`,
    NOT_EQUAL: `nicht gleich`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Benachrichtigung erfolgreich hinzugefügt`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Benachrichtigung erfolgreich gelöscht`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Benachrichtigungssequenz erfolgreich aktualisiert`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Benachrichtigung erfolgreich aktualisiert`,
    NOTIFICATIONS: `Benachrichtigungen`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Anzahl der Diagnoseereignisse`,
    NUMBER_OF_OPEN_PIPS: `{number} offene PIPs`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Anzahl der Reparaturereignisse`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Anzahl der Austauschereignisse`,
    OLD_LABOR_RATE: `Bisheriger Lohntarif`,
    ON_SHELF: `Im Regal`,
    ON_SHELF_COST: `Zusatzkosten`,
    ONE_ITEM_MUST_BE_SELECTED: `Eine Position muss ausgewählt sein`,
    OPEN: `Offen`,
    OPEN_PART_REQUESTS: `Offene Teileanforderungen`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Offene Teileanforderungen ({count})`,
    OPEN_PIP_COUNT: `Anzahl der offenen PIPs`,
    OPEN_PIP_PROGRAMS: `Programmregister`,
    OPEN_PIPS: `Offene Verbesserungsprogramme`,
    OPEN_PIPS_REPORT: `PIP Report öffnen`,
    OPEN_PIPS_TAB: `Offene PIPs ({count})`,
    OPEN_PIPS_Y_N: `Offene Produktverbesserungsprogramme (J/N)`,
    OPERATORS_COMPLAINT: `Kundenreklamation`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `Beschwerde des Bedieners muss angegeben werden`,
    OPERATORS_MANUAL_NUMBER: `Betriebsanleitungsnummer`,
    OPTION_CODE: `Option Code`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Option Code Created Successfully`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Option Code Deleted Successfully`,
    OPTION_CODES: `Optionkodes`,
    OR: `oder`,
    ORIGINAL_CLAIM_VALUE: `Ursprünglicher Antragswert`,
    ORIGINAL_SUBMISSION_DATE: `Datum des ursprünglichen Angebots`,
    ORIGINALLY_SUBMITTED: `Ursprünglich übertragen`,
    OTHER: `Sonstiges`,
    OTHER_AMOUNT_OF_USE: `Sonstige Maschinennutzung`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Sonstige angeforderte Maschinennutzung`,
    OTHER_CREDIT: `Sonderkosten`,
    OTHER_CREDIT_1: `Sonderkosten 1`,
    OTHER_CREDIT_2: `Sonderkosten 2`,
    OTHER_CREDIT_3: `Sonderkosten 3`,
    OTHER_CREDIT_ADJUSTMENT: `Sonstige Bonitätsanpassung`,
    OTHER_CREDIT_ITEM_DETAILS: `Sonderkosten - {quantity} {unit} {description}`,
    OTHER_CREDIT_TOTAL: `Gesamt Sonderkosten`,
    OTHER_CREDITS: `Sonderkosten`,
    OTHER_CREDITS_WITH_COUNT: `Sonstige Gutschriften ({count})`,
    OTHER_INSTRUCTIONS: `Weitere Anweisungen`,
    OUTPUT_PIN: `Ausgabe PIN`,
    OVERDUE: `Überfällig`,
    OVERRIDE_ACCOUNT: `Übersteuerungskonto`,
    OVERRIDE_EFFECTIVE_DATE: `Datum des Überschreibens`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Übersteuerung des empfohlenen Kontos`,
    OWNERSHIP_STATUS: `Besitzerstatus`,
    OWNERSHIP_STATUS_IS_REQUIRED: `Eigentümerstatus ist erforderlich`,
    PART: `Material`,
    PART_1: `Material 1`,
    PART_2: `Material 2`,
    PART_3: `Material 3`,
    PART_4: `Material 4`,
    PART_5: `Material 5`,
    PART_6: `Material 6`,
    PART_7: `Material 7`,
    PART_8: `Material 8`,
    PART_9: `Material 9`,
    PART_10: `Material 10`,
    PART_AMONT_OF_USE: `Ersatzteilnutzung`,
    PART_FAMILY: `Teilefamilie`,
    PART_ITEM_DETAILS: `Teile – {quantity} {description} Teil Nr. {partNumber}`,
    PART_NUMBER: `Teilenummer`,
    PART_REQUEST: `Teilanforderung`,
    PART_REQUEST_NUMBER: `Teileanforderung {rgaNumber}`,
    PART_REQUEST_STATUS: `Teileanforderungsstatus`,
    PART_REQUESTS: `Teilanforderungen`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Antragsnummer, mindestens 4 Zeichen eingeben`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `PIN muss mindestens 4 Zeichen enthalten`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `Bei der DTAC-Fallnummernsuche muss die vollständige DTAC-Fallnummer eingegeben werden, mindestens 4 Zeichen`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Vollständige DTAC-Fallnummer eingeben`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `Bei der Teilenummernsuche müssen mindestens 4 Zeichen eingegeben werden`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Teilenummer, mindestens 4 Zeichen eingeben`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `Bei der Teileanforderungsnummernsuche müssen mindestens 4 Zeichen eingegeben werden`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Teileanforderungsnummer eingeben, mindestens 4 Zeichen`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `Bei der PIN-Suche müssen mindestens 4 Zeichen eingegeben werden`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `PIN eingeben, mindestens 4 Zeichen`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `Bei der Arbeitsauftragsuche muss der vollständige Arbeitsauftrag eingegeben werden, mindestens 2 Zeichen`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Vollständigen Arbeitsauftrag eingeben`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Teileanforderung erfolgreich aktualisiert`,
    PART_RETURN: `Teilrückgabe`,
    PART_RETURNS: `Teilrückgaben`,
    PART_SERIAL_NUMBER: `Seriennummer des Teils`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `Teileseriennummer ist erforderlich`,
    PART_TOTAL: `Teilesumme`,
    PART_TYPE: `Teiltyp`,
    PART_USE: `Teilenutzung`,
    PART_VALUE: `EZ-Teil Wert`,
    PARTIAL_DEBIT: `Teilweise Lastschrift`,
    PARTICIPANT: `Beteiligter`,
    PARTS: `Material`,
    PARTS_ADDITIVE: `Teilezuschlag`,
    PARTS_ADJUSTMENT:`Einstellung der Teile`,
    PARTS_COVERAGE_SEARCH: `Teildeckungsuche`,
    PARTS_TEMPLATE: `Teilevorlage`,
    PARTS_USE: `Ersatzteilnutzung`,
    PARTS_USE_IS_REQUIRED: `Teilenutzung ist erforderlich`,
    PARTS_WITH_COUNT: `Teile ({count})`,
    PARTS_WITH_PARENTHESES: `Teil(e)`,
    PAST_DUE: `Überfällig`,
    PAYER_ACCOUNT: `Konto des Zahlenden`,
    PC_LIMIT:`Ballengrenze`,
    PERCENT_COMPLETE: `Prozent abgeschlossen`,
    PERCENTAGE: `Prozente`,
    PERCENTAGE_DEBIT: `Lastschrift in Prozent`,
    PERCENTAGE_SYMBOL: `{percentage}%`,
    PERCENTAGE_TO_DEBIT: `Prozentsatz der Lastschrift`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT:`Für Maschinen, die dauerhaft außer Betrieb sind, ist als Nachweis, dass die Maschine zu keinem zukünftigen Zeitpunkt umgebaut, repariert oder wiederverwendet werden kann, ein Bild beizulegen. Maschinen, die dauerhaft außer Betrieb sind,kommen nicht für Produktverbesserungsprogramme (PIP) irgendeiner Art infrage.`,
    PERSON_RESPONSIBLE: `Verantwortliche Person`,
    PHONE: `Telefon`,
    PHONE_REQUIRED: `Telefon erforderlich`,
    PICTURE: `Bild`,
    PICTURE_REQUEST: `Bildanfrage`,
    PICTURE_REQUEST_STATUS: `Bildanforderungsstatus`,
    PICTURE_REQUEST_STATUS_ERROR: `Anhänge sind bereit, mit dieser Anfrage eingereicht zu werden.`,
    PIN: `PIN (Seriennummer)`,
    PIN_CREATED_SUCCESSFULLY: `PIN erfolgreich erstellt`,
    PIN_CROSS_REFERENCE: `Seriennummer Verwendungs-nachweis`,
    PIN_INVALID: `PIN ungültig`,
    PIN_IS_REQUIRED: `PIN muss angegeben werden.`,
    PIN_REQUIRED: `PIN erforderlich`,
    PIN_SEARCH: `PIN-Suche`,
    PIN_SEARCH_INFORMATION: `PIN-Suchinformationen`,
    PIN_TRANSFER_INFORMATION: `Informationen zur Klemmenübertragung`,
    PINS: `PINs`,
    PINS_NOT_REGISTERED: `Nicht übergebene PINs`,
    PIP: `Verbesserungsprogramm`,
    PIP_CODE: `PIP-Code`,
    PIP_CODE_CREATED_SUCCESSFULLY: `PIP-Code-Anforderung erfolgreich erstellt`,
    PIP_CODE_REQUEST: `PIP-Code-Antrag`,
    PIP_CODE_REQUEST_APPROVED: `PIP-Code-Antrag genehmigt`,
    PIP_CODE_REQUEST_REJECTED: `PIP-Code-Antrag abgelehnt`,
    PIP_CODE_REQUESTS_WITH_COUNT: `PIP-Code-Anträge ({count})`,
    PIP_COMPLETION_STATUS: `Abschluss-Status`,
    PIP_DETAILS: `PIP Details`,
    PIP_HISTORY: `Verbesserungsprogramme`,
    PIP_ID: `PIP-Nr.`,
    PIP_NUMBER: `Programmnummer`,
    PIP_PROGRAM: `Produktverbesserungsprogramm`,
    PIP_PROGRAM_IS_REQUIRED: `Produktverbesserungsprogramm ist erforderlich`,
    PIP_PROGRAMS: `PIP-Programme`,
    PIP_SEARCH: `Programm-Suche`,
    PIP_STATUS: `PIP-Status`,
    PIP_TYPE: `PIP-Typ`,
    PIP_TYPES: `PIP-Typen`,
    PIPS: `Verbesserungsprogramme`,
    PIPS_UNPAID_LABOR_ADDITIVE: `PIPs nicht gezahlte Arbeitszeitzuschläge`,
    PLAN_DESCRIPTION: `Planbeschreibung`,
    PLAN_END_DATE: `Enddatum des Plans`,
    PLAN_ENDS: `Plan endet`,
    PLAN_NAME: `Planname`,
    PLAN_NAME_IS_REQUIRED: `Planname ist erforderlich`,
    PLAN_NAMES: `Planname`,
    PLAN_START_DATE: `Startdatum des Plans`,
    PLAN_STARTS: `Plan beginnt`,
    PLANNED_BY: `Nach Geplant`,
    PLANT: `Werk`,
    PLATE_REQUEST_INFORMATION: `Informationen zur Plattenanforderung`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Bitte ein Hauptkonto auswählen`,
    PLEASE_SELECT_CLAIM_TYPE: `Wählen Sie die Antragsart aus.`,
    POLISH: `Polnisch`,
    PORTUGUESE: `Portugiesisch`,
    POSTAGE_DELIVERY_DATE: `Lieferdatum`,
    POSTAL_CODE: `Postleitzahl`,
    POSTAL_CODE_REQUIRED: `Postleitzahl erforderlich`,
    POSTAL_TRACKING_NUMBER: `Sendungsnummer`,
    POTENTIAL_RESPONSIBLE_DEALER: `Potenziell verantwortlicher Vertriebspartner`,
    PRE_DELIVERY_INSPECTION: `Inspektion vor Übergabe`,
    PREFERRED_THEME: `Bevorzugtes Thema`,
    PREPARE_AUDIT: `Audit vorbereiten`,
    PREPARED: `Vorbereitet`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `Vorbereiten der Prüfung für {dealer}`,
    PREVIOUS_AMOUNT_OF_USE: `Frühere Maschinennutzung`,
    PREVIOUS_INVOICE_NUMBER: `Vorherige Rechnungsnummer`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `Vorherige Rechnungsnummer ist erforderlich`,
    PREVIOUS_MONTH: `Vorheriger Monat`,
    PRICE: `Preis`,
    PRICING_SUMMARY: `Preisübersicht`,
    PRIMARY_ACTION: `Bevorzugte Aktion`,
    PRIMARY_LANGUAGE: `Bevorzugte Sprache`,
    PRINT: `Drucken`,
    PRINT_CLAIM: `Antrag drucken`,
    PRINT_REGISTRATION_FORM: `Print Registration Form`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Product registered to First Owner. Would you like to print the registration form now?`,
    PRINT_TO_PDF: `PDF Drucken`,
    PRIORITY: `Priorität`,
    PRNT_CLM: `Antrag anzeigen`,
    PROCESS_DATE: `Bearbeitungsdatum`,
    PROCESSED: `Bearbeitet`,
    PROCESSED_PART_REQUESTS: `Bearbeitete Teileanforderungen`,
    PROCESSING_STATUS: `Bearbeitungsstand`,
    PROCESSING_STATUS_DESCRIPTION: `Bezeichnung Bearbeitungsstatus`,
    PRODUCT_DETAILS: `Produktdetails`,
    PRODUCT_HIERARCHY: `Produkthierarchie`,
    PRODUCT_INFORMATION: `Maschineninformation`,
    PRODUCT_REGISTERED: `Registriertes Produkt`,
    PRODUCT_REGISTRATION: `Produktregistrierung`,
    PRODUCT_REGISTRATION_PENDED: `Produktregistrierung schwebend`,
    PRODUCT_TRACKING: `Maschinenverfolgung`,
    PRODUCTS: `Produkte`,
    PRODUCTS_BY_CUSTOMER: `Produkte nach Kunden`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Aufgrund eines vorübergehenden Systemkonnektivitätsproblems fehlen möglicherweise die historischen PINs in den Suchergebnissen.`,
    PRODUCTS_WITH_COUNT: `Produkte ({count})`,
    PROGRAM: `Programm`,
    PROGRAM_DESCRIPTION: `Programmbeschreibung`,
    PROGRAM_IS_REQUIRED: `Programmname ist erforderlich.`,
    PROGRAM_NAME: `Programmname`,
    PROGRAM_NAME_IS_REQUIRED: `Programmname ist erforderlich.`,
    PROGRAM_NUMBER: `Programmnummer`,
    PRT: `Maschinenverfolgung`,
    PRTS: `PRTs`,
    PURCHASE_INFO: `Informationen zum Kauf`,
    PURCHASE_ORDER: `Kaufauftrag`,
    PURCHASE_ORDER_IS_REQUIRED: `Kaufauftrag ist erforderlich`,
    PURCHASER_TYPE: `Kauftyp`,
    PURCHASER_TYPE_REQUIRED: `Art des Käufers erforderlich`,
    PUSH_XML: `XML erneut senden`,
    QTY: `Menge`,
    QUALIFY_FOR_EMISSIONS: `Erfüllt die Anforderungen für Emissionen`,
    QUANTITY: `Menge`,
    QUANTITY_1: `Menge 1`,
    QUANTITY_2: `Menge 2`,
    QUANTITY_3: `Menge 3`,
    QUANTITY_4: `Menge 4`,
    QUANTITY_5: `Menge 5`,
    QUANTITY_6: `Menge 6`,
    QUANTITY_7: `Menge 7`,
    QUANTITY_8: `Menge 8`,
    QUANTITY_9: `Menge 9`,
    QUANTITY_10: `Menge 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `Anfrage muss aus mind. 3Zeichen bestehen`,
    QUEST_DESC: `Zweifelhafte Beschreibung`,
    QUESTIONABLE_PART: `Fragliches Teil`,
    QUEUED: `Warteschlange`,
    READING_DATE: `Auslesedatum`,
    REASON: `Grund`,
    REASON_EVENT_NUMBER: `Ereignisnummer Grund`,
    REASON_FOR_CHANGE: `Grund der Änderung`,
    REASON_FOR_DEBIT: `Grund der Lastschrift`,
    REASON_FOR_MISSING_PLATE: `Grund für fehlende Platte`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Grund für fehlende Platte erforderlich`,
    REASON_FOR_OVERRIDE: `Grund für Überschreiben`,
    REASON_FOR_REFUSAL: `Ablehnungsgrund`,
    REASON_FOR_RETURN: `Rücksendegrund`,
    REASON_FOR_RETURN_IS_REQUIRED: `Rücksendegrund ist erforderlich`,
    REASON_FOR_TRANSFER: `Grund für Umlagerung`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `Grund für Umlagerung muss alphanumerische Zeichen enthalten`,
    REASON_FOR_TRANSFER_REJECTION: `Grund für Ablehnung der Übertragung`,
    RECIPIENT_DEALER_OR_TCSM: `Empfänger(Vertriebspartner oder TBL)`,
    RECIPIENT_MAILING: `Empfänger der Postsendung`,
    RECOMMENDATION: `Empfehlung`,
    RECOMMENDATION_DATE: `Empfehlungsdatum`,
    RECOMMENDED_ACCOUNT: `Empfohlenes Konto`,
    RECONCILE: `Abstimmen`,
    RECONCILE_CLAIM: `Antrag abstimmen`,
    RECONCILED: `ABGEGLICHEN`,
    RECORD_AUDIT: `Prüfung aufzeichnen`,
    RECORD_AUDIT_FOR: `Prüfung aufzeichnen für {dealer}`,
    RECORDS_FOUND: `{countToDisplay} {count, plural, one {Schriftgut} other {Schriftgutteile}} gefunden`,
    RECOVERABLE_TAXES: `Erstattungsfähige Steuern`,
    RECOVERED: `Reguliert`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Mit verpassten Arbeitszeitvergütungen reguliert`,
    RECOVERED_WITHOUT_ADDITIVES: `Ohne Arbeitszeitvergütung reguliert`,
    RECOVERY: `Rückerstattung`,
    RED_MUST_BE_LESS_THAN_YELLOW: `Roter Anzeigenwert muss niedriger sein als der gelbe Anzeigenwert`,
    REFERENCE_1: `Referenz 1`,
    REFERENCE_2: `Referenz 2`,
    REFERENCE_INFORMATION: `Referenzinformationen`,
    REFERENCE_NUMBER1: `Referenznummer 1`,
    REFERENCE_NUMBER2: `Referenznummer 2`,
    REGION: `Region`,
    REGISTER: `Registrieren`,
    REGISTER_A_PRODUCT_BY_PIN: `Produkt anhand von PIN registrieren`,
    REGISTER_A_PRODUCT_TO_ADD: `Register Product to add to the Warranty System`,
    REGISTER_ANOTHER_PRODUCT: `Ein weiteres Produkt registrieren`,
    REGISTER_PRODUCT: `Maschine übergeben`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `PIN übergeben und übergeben einen weiteren PIN`,
    REGISTERED: `Registriert`,
    REGISTRATION: `Registrierung`,
    REGISTRATION_DATE: `Zulassungsdatum`,
    REGISTRATION_DATES: `Registrierungsdaten`,
    REGISTRATION_FORM: `Registrierungsformular`,
    REGISTRATION_HISTORY: `Registrierungsverlauf`,
    REGISTRATION_NOT_ALLOWED: `Registrierung für dieses Produkt nicht möglich`,
    REGISTRATION_REVIEW: `Prüfung der Registrierung`,
    REGISTRATION_REVIEW_TAB: `Prüfung der Registrierung ({count})`,
    REGISTRATION_STATUS: `Zulassungsstatus`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `Registrierungsstatus kann nicht Neu sein`,
    REGISTRATION_STATUS_REQUIRED: `Registrierungsstatus erforderlich`,
    REGISTRATION_SUCCESS: `Registrierung erfolgreich`,
    REGISTRATION_TYPE: `Registrierungsart`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Registrierungsart kann nicht Neu sein`,
    REGISTRATION_TYPE_REQUIRED: `Registrierungsart erforderlich`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Registrierung erfolgreich aktualisiert`,
    REGISTRATIONS_REVIEW: `Prüfung der Registrierungen`,
    REIMBURSED: `Vergütete Betrag`,
    REIMBURSED_AMOUNT: `Erstatteter Betrag`,
    REIMBURSED_PERCENTAGE: `Erstatteter Prozentsatz`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Anzeige für den Erstattungsprozentsatz`,
    REIMBURSEMENT_DETAILS: `Angaben zur Rückerstattung`,
    REIMBURSEMENT_PERCENTAGE: `Erstattungsprozentsatz`,
    REIMBURSEMENT_SUMMARY: `Erstattungsübersicht`,
    REJECT: `Ablehnen`,
    REJECT_LABOR_RATE: `Lohntarif ablehnen`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Antrag auf Sonderentschädigung ablehnen`,
    REJECTED: `Abgelehnt`,
    REJECTED_APPEAL: `Abgelehnter Appell`,
    RELATIONSHIP: `Beziehung`,
    RELATIONSHIP_IS_REQUIRED: `Beziehung ist erforderlich`,
    REMOVE_FILTER: `Filter ausbauen`,
    REMOVE_FROM_AUDIT: `Aus Prüfung entfernen`,
    REMOVE_LAYOUT: `Layout entfernen`,
    RENTAL_PINS: `PINs für Miete`,
    REPAIR_DATE: `Reparaturdatum`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `Reparaturdatum kann nicht vor Fehlerdatum liegen`,
    REPAIR_NUMBER: `Reparaturnummer`,
    REPAIR_NUMBER_IS_REQUIRED: `Reparaturnummer ist erforderlich`,
    REPAIR_REPLACE_INDICATOR: `Reparatur/Austausch-Kennzeichen`,
    REPAIRED: `Reparaturdatum`,
    REPAIRED_DATE: `Reparaturdatum`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `Reparaturdatum darf nicht vor dem Datum des Fehlschlags liegen`,
    REPAIRED_DATE_IS_REQUIRED: `Reparaturdatum ist erforderlich`,
    REPORT_DATE: `Berichtsdatum`,
    REPORT_NUMBER: `Reportnummer`,
    REPORTS: `Berichte`,
    REQ_ADDL: `Gutschirift berichtigen`,
    REQUEST: `Anforderung`,
    REQUEST_DATE: `Antragsdatum`,
    REQUEST_DETAILS: `Anfragedetails`,
    REQUEST_DUPLICATE_PIN_PLATE: `Doppeltes PIN-Schild anfordern`,
    REQUEST_FORM: `Anforderungsformular`,
    REQUEST_PIP_CODE: `PIP-Code anfordern`,
    REQUEST_STATUS: `Anforderungsstatus`,
    REQUEST_SUBMITTED: `Antrag übermittelt`,
    REQUEST_TYPE: `Anfragetyp`,
    REQUEST_UPDATED_SUCCESSFULLY: `Anfrage erfolgreich aktualisiert`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Lastschrift für Garantiemeldung beantragen`,
    REQUESTED: `Angefordert`,
    REQUESTED_BY: `Beantragt von`,
    REQUESTED_DATE: `Anforderungsdatum`,
    REQUESTED_DATES: `Anforderungsdaten`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Angeforderte Diagnosebetrag`,
    REQUESTED_DIAGNOSTIC_HOURS: `Angeforderte Diagnosestunden`,
    REQUESTED_LABOR_AMOUNT: `Angeforderte Arbeitsmenge`,
    REQUESTED_LABOR_HOURS: `Angeforderte Arbeitsstunden`,
    REQUESTED_OTHER_CREDITS: `Angeforderte sonstige Gutschriften`,
    REQUESTED_PARTS: `Angeforderte Teile`,
    REQUESTED_REPAIR_AMOUNT: `Angeforderter Reparaturbetrag`,
    REQUESTED_REPAIR_HOURS: `Angeforderte Reparaturstunden`,
    REQUESTED_TRAVEL_TOTAL: `Beantragte Fahrtkosten - Gesamt`,
    REQUESTER_TCSM: `Auftraggeber (TBL)`,
    REQUESTER_TCSM_REQUIRED: `Anforderer (TBL) erforderlich`,
    REQUIRED: `*erforderlich`,
    REQUIRED_CRITERIA: `Erforderliche Kriterien`,
    REQUIRED_ITEMS: `Erforderliche Posten`,
    RESEND_XML: `XML erneut senden`,
    RESET: `Zurücksetzen`,
    RESPONDENT_INFORMATION: `Angaben zum Antragsgegner`,
    RESPONSIBILITY_OF: `Verantwortlichkeit von`,
    RESPONSIBLE_ACCOUNT: `Konto der zuständigen Person`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `Konto der zuständigen Person muss angegeben werden`,
    RESPONSIBLE_DEALER: `Verantwortlicher Händler`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `Anzeige der ersten 100 Ergebnisse. Für vollständige Ergebnisse herunterladen`,
    RET: `Rückgabe`,
    RETAIL_INSTALL: `Verkauf/Einbau`,
    RETAIL_INSTALL_DATE: `Verkaufs-/Einbaudatum`,
    RETAIL_INSTALL_IS_REQUIRED: `Verkauf/Einbau ist erforderlich`,
    RETAILER_NAME: `Einzelhändler`,
    RETAILER_NAME_IS_REQUIRED: `Einzelhändlername erforderlich`,
    RETRY: `erneut versuchen`,
    RETURN: `Rückgabe`,
    RETURN_LABOR_RATE: `Arbeitslohn-Rückerstattung`,
    RETURN_REQUEST: `Rücksendeanfrage`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Antrag auf Sonderentschädigung zurückgeben`,
    RETURN_STATUS: `Rückgabestatus`,
    RETURNED: `Zurückgeschickt`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `Rückgabedatum darf nicht vor dem Lieferdatum liegen`,
    RETURNED_DATE_IS_REQUIRED: `Rückgabedatum ist erforderlich`,
    RETURNED_MACHINE_STATUS_UPDATE: `Aktualisierung des Maschinenstatus bei Rückgabe`,
    REVIEW_DEALER_RECOMMENDATIONS: `Sind Sie sicher, dass Sie die PINs zur Überprüfung markieren möchten?`,
    REVISE: `Überarbeiten`,
    REVISED: `Überarbeitete`,
    ROLLING_12_CREDIT_AMOUNT: `Laufend 12 Guthabenbetrag`,
    ROLLING_12_MONTHS: `Vergangene 12 Monate`,
    RUN_REPORT: `Bericht erstellen`,
    RUSSIAN: `Russisch`,
    SAP_DOWN_WARNING: `Die Funktionalität des Garantiesystems ist beeinträchtigt. Wir arbeiten daran, dies so schnell wie möglich zu korrigieren. Aktualisieren Sie den Browser, um die Verfügbarkeit des Systems zu überprüfen.`,
    SAVE: `Speichern`,
    SAVE_AS_DRAFT: `Als Entwurf sichern`,
    SAVE_AS_NEW_LAYOUT: `Als neues Layout speichern`,
    SAVE_AUDIT: `Prüfung speichern`,
    SAVE_CHANGES: `Änderungen speichern`,
    SAVE_TO_VALIDATE: `Zum Validieren speichern`,
    SAVE_VALD: `Speichern und prüfen`,
    SAVE_VALIDATE: `Speichern und prüfen`,
    SEARCH: `Suchen`,
    SEARCH_BOX_PLACEHOLDER: `PIN, Seriennr., Fallnr., DTAC-Fall oder Kundenname eingeben`,
    SEARCH_BY_CLAIM_TYPE: `Vollständige Antragsart eingeben`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `Bei der Antragssuche muss die vollständige Antragsart eingegeben werden, 4 bis 9 Zeichen`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Vollständige Schadensteilnummer eingeben`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `Bei der Antragssuche muss die vollständige Schadensteilnummer mindestens 4 Zeichen`,
    SEARCH_BY_WORK_ORDER: `Arbeitsauftrag eingeben, mindestens 2 Zeichen`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `Arbeitsauftrag muss mindestens 2 Zeichen`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Vollständige Antragsnummer eingeben`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `Bei der Antragssuche muss eine vollständige Antragsnummer angegeben werden, die 4 bis 9 Zeichen umfasst`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Vollständige Komponenten-Seriennummer eingeben`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `Komponentensuche muss vollständige Seriennummer sein, mindestens 1 Zeichen`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `PIN eingeben`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Vollständige Modellnummer eingeben`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `Bei der Modellsuche muss eine vollständige Modellnummer angegeben werden, die 3 bis 12 Zeichen umfasst`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `PIN eingeben, mindestens 6 Zeichen`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `Bei der PIN-Suche müssen 6 bis 17 Zeichen eingegeben werden`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `PIP-Nummer eingeben, mindestens 4 Zeichen`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `Bei der PIP-Suche muss eine Nummer eingegeben werden, die 4 bis 12 Zeichen umfasst`,
    SEARCH_RESULTS_TAB: `Suchergebnisse ({count})`,
    SECOND_SHIP_TO_LOCATION: `Zweite Lieferung zum Standort`,
    SELECT: `Auswählen`,
    SELECT_A_RANGE: `Bereich auswählen`,
    SELECT_ALL: `Alle auswählen`,
    SELECT_AUTO_SUBMIT: `Automatische Übermittlung auswählen`,
    SELECT_BRANCH: `Branche auswählen`,
    SELECT_CLAIM_TYPE: `Antragstyp auswählen`,
    SELECT_CLAIMS: `Anträge selektieren`,
    SELECT_CLAIMS_WITHIN_DATE_RANGE: `Anträge innerhalb der ausgesuchten Daten selektieren`,
    SELECT_COLUMNS: `Spalten auswählen`,
    SELECT_COUNTRY: `Land wählen`,
    SELECT_CSV_SEPARATOR: `CSV-Separator auswählen`,
    SELECT_DATE_FORMAT: `Datumsformat auswählen`,
    SELECT_DEALERS_AND_STATUS: `Händler und Status auswählen`,
    SELECT_DECIMAL_FORMAT: `Dezimalformat auswählen`,
    SELECT_DISPLAY_FORMAT: `Anzeigeformat auswählen`,
    SELECT_FACTORY: `Wählen Sie ein Werk aus.`,
    SELECT_LANGUAGE: `Sprache wählen`,
    SELECT_LAYOUT: `Auswählen Layout`,
    SELECT_NEW_CLAIMS: `Neue Anträge selektieren`,
    SELECT_PIP_CODE: `PIP-Code auswählen`,
    SELECT_PLAN_NAMES: `Plannamen auswählen`,
    SELECT_SERVICE_INTERVAL_TYPES: `Wartungintervall-Typen auswählen`,
    SELECT_SORT_BY: `Sortieren nach Auswählen`,
    SELECT_SORT_DIRECTION: `Sortierrichtung Auswählen`,
    SELECT_STATE: `Bundesland auswählen`,
    SELECT_STATUS: `Status auswählen`,
    SELECT_TERRITORY: `Gebiet wählen`,
    SELECT_THEME: `Thema auswählen`,
    SELECT_TIME_ZONE: `Zeitzone auswählen`,
    SELECT_VALUES_TO_APPROVE: `Zu bestätigende Werte auswählen`,
    SELECTED_COLUMNS: `Spalten Ausgewählte`,
    SELECTED_FOR_AUDIT: `Für Prüfung ausgewählt`,
    SELECTED_FOR_AUDIT_VSR: `Siehe DTAC-Lösung 221475 für die erforderlichen Prüfunterlagen und die für diesen Erstattungsanspruch erforderlichen Anlagen.`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `Auswahl mehrerer Konten und Garantietypen beeinträchtigt Leistung`,
    SEND: `Senden`,
    SERIAL_NUMBER: `Seriennummer`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Seriennummer / Rechnungsnummer`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `Die Antwort des Server dauerte zu lange und die Anforderung wurde abgebrochen. Versuchen Sie es mit einer konkreteren Anforderung oder später noch einmal.`,
    SERVICE_DATE_IS_REQUIRED: `Wartungsdatum erforderlich`,
    SERVICE_INTERVAL: `Kundendienstinterval`,
    SERVICE_INTERVAL_BEGIN_DATE: `Wartungsintervall-Startdatum`,
    SERVICE_INTERVAL_END_DATE: `Wartungsintervall-Enddatum`,
    SERVICE_INTERVAL_IS_REQUIRED: `Wartungsintervall ist erforderlich`,
    SERVICE_INTERVAL_NUMBER: `Wartungsintervallnummer`,
    SERVICE_INTERVAL_STATUS: `Kundendienstintervalstatus`,
    SERVICE_INTERVAL_TYPE: `Kundendienstintervaltyp`,
    SERVICE_INTERVAL_TYPES: `Wartungsintervall-Typ`,
    SERVICE_PART: `Serviceteil`,
    SERVICE_UNAVAILABLE: `Wartung nicht verfügbar`,
    SERVICED: `Gewartet`,
    SERVICED_DATE_IS_REQUIRED: `Servicedatum ist erforderlich.`,
    SERVICED_IS_REQUIRED: `Servicedatum ist erforderlich.`,
    SET_AS_DEFAULT: `Als Standard einstellen`,
    SETTINGS: `Meine Einstellungen`,
    SETTLED: `Abgerechnet`,
    SETTLEMENT_NO_REGISTRATION: `Abrechnung ohne Registrierung`,
    SETUP: `Einrichtung`,
    SETUP_DATE_IS_REQUIRED: `Einrichtungsdatum ist erforderlich`,
    SETUP_IS_REQUIRED: `Einrichtung ist erforderlich`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Lieferung an`,
    SHIPPED: `Versandt`,
    SHIPPING_ID: `Versand-ID`,
    SHIPPING_ID_REQUIRED: `Versand-ID erforderlich`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Versandinformationen/Spezialanweisungen`,
    SHIPPING_INSTRUCTIONS: `Versandanweisungen`,
    SHORT_TEXT: `Kurzer Text`,
    SHORT_TEXT_IS_REQUIRED: `Kurztext is Required`,
    SHOW_ALL: `Zeige alles ({count})`,
    SHOW_EXCLUDED: `Ausgeschlossen anzeigen`,
    SHOW_MORE: `Zeig mehr`,
    SHOW_MORE_GROUPS: `{countToDisplay} weitere {count, plural, one {Gruppe} other {Gruppen}} anzeigen`,
    SHOW_RED_IF_LESS_THAN: `Rot anzeigen, wenn weniger als`,
    SHOW_REIMBURSED_AMOUNT: `Erstatteten Betrag anzeigen`,
    SHOW_REIMBURSED_PERCENTAGE: `Erstatteten Prozentsatz anzeigen`,
    SHOW_YELLOW_IF_LESS_THAN: `Gelb anzeigen, wenn weniger als`,
    SIGN_IN_REQUIRED: `Anmelden erforderlich`,
    SIGN_OUT: `Abmelden`,
    SKIP_AUDIT: `Audit überspringen`,
    SKIP_AUDIT_SUCCESS: `Die Prüfung wurde übersprungen, und der Fälligkeitstermin ist nun in der Zukunft.`,
    SOME_PARTS_RETURNED: `Einige Teile zurückgesandt`,
    SORT_BY: `Sortieren nach`,
    SPANISH: `Spanisch`,
    SPECIAL_ALLOWANCE: `Kulanzantrag`,
    SPECIAL_ALLOWANCE_CALCULATION: `Kulanzkalkulation`,
    SPECIAL_ALLOWANCE_CLAIM: `Antrag auf Sonderentschädigung`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Status des Antrags auf Sonderentschädigung`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Status des Antrags auf Sonderentschädigung`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Status des Antrags auf Sonderentschädigung aktualisiert`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Antrag auf Sonderentschädigung – {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Anträge auf Sonderentschädigung ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Sonderentschädigungsbeiträge`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Sonderentschädigungsbeschreibung`,
    SPECIAL_ALLOWANCE_TYPE: `Kulanzart`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Kulanzart ist erforderlich`,
    SPECIAL_INSTRUCTIONS: `Besondere Hinweise`,
    SPG: `SPG`,
    SPGS: `SPGs`,
    STANDARD_VIEW: `Gesamtansicht`,
    START_AMOUNT_OF_USE: `Anfängliche Betriebsstunden`,
    STARTS: `beginnt`,
    STARTS_WITH: `beginnt mit`,
    STATE: `State`,
    STATE_PROVINCE: `Bundesland`,
    STATE_PROVINCE_REQUIRED: `Bundesland/Provinz erforderlich`,
    STATUS: `Status`,
    STATUS_CHANGE_REQUEST: `Statusänderungsanforderung`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Statusänderungsanforderung erfolgreich erstellt`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Maschinenstatusanforderung wurde erfolgreich aktualisiert`,
    STATUS_FOR: `Status für {pin}`,
    STATUS_INDICATOR: `Statusindikator`,
    STATUS_REASON: `Status-Begründung`,
    STOLEN_DATE: `Datum an dem die Maschine gestohlen wurde`,
    STORE: `Laden`,
    STORE_IS_REQUIRED: `Laden ist erforderlich`,
    STORE_NUMBER_IS_REQUIRED: `Ladennummer ist erforderlich`,
    STREET_1: `Straße 1`,
    STREET_2: `Straße`,
    SUB: `Senden`,
    SUB_CLAIM_TYPE: `Sub-Antragsart`,
    SUB_TYPE: `Untertyp`,
    SUBMISSION_DATE: `Einreichungsdatum`,
    SUBMIT: `Senden`,
    SUBMIT_AUDIT: `Prüfung übermitteln`,
    SUBMIT_AUDIT_FOR: `Prüfung übermitteln für {dealer}`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Vollständigen Lastschriftantrag übermitteln für {claimNumber}`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Einen Teil des Lastschriftantrags übermitteln für {claimNumber}`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Erstattungsanspruch für Lastschrift in % für {claimNumber} einreichen`,
    SUBMIT_REQUEST: `Anfrage übermitteln`,
    SUBMITTED: `Eingereicht`,
    SUBMITTED_AVAILABLE_TO_EDIT: `Eingereicht (Bearbeitbar)`,
    SUCCESS: `Erfolg`,
    SUCCESS_MESSAGE_TITLE: `Ein Vorgang war erfolgreich:`,
    SUCCESS_MESSAGES_TITLE: `Mehrere Vorgänge waren erfolgreich:`,
    SUPPLIER_WARRANTY: `Lieferantengarantie`,
    SURVEY_QUESTIONS: `Fragepunkte`,
    SUSPENDED: `Suspendiert`,
    SWEDISH: `Schwedisch`,
    SYSTEM_SELECTED_CLAIMS: `Vom System ausgewählte Anträge`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Vom System ausgewählte Anträge ({count})`,
    TABM: `TABM`,
    TAX: `Steuern`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `TBL-Kommentare`,
    TCSM_ID: `TCSM ID`,
    TECH_ID: `Techniker`,
    TERMINATED: `Beendet`,
    TERMINATES: `Endet`,
    TERRITORY: `Gebiet`,
    TEST: `Test`,
    TEST_RESULTS_CODE: `Testergebniskode`,
    THEME: `Thema`,
    TIME_LIMIT: `Zeitbegrenzung`,
    TIME_ZONE: `Zeitzone`,
    TITLE: `Titel`,
    TITLE_IS_REQUIRED: `Titel ist Erforderlich`,
    TO: `bis`,
    TODAY: `Heute`,
    TOO_MANY_RESULTS: `Ihre Anforderung hat zu viele Ergebnisse erbracht. Bitte schränken Sie Ihre Suchbegriffe ein und versuchen Sie es erneut.`,
    TOTAL: `Gesamtbetrag`,
    TOTAL_AMOUNT: `Gesamtbetrag`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `Gesamt in PLN`,
    TOTAL_APPROVED: `Insgesamt genehmigt`,
    TOTAL_APPROVED_CLAIM_VALUE: `Gesamtantragswert (genehm.)`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Gesamtantragswert (annerkannt inkl. MwSt.)`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Insgesamt genehmigt ohne Zuschläge`,
    TOTAL_CONTRIBUTION: `Gesamtbeitrag`,
    TOTAL_REIMBURSED: `Ingesamt erstattet`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Gesamterstattung ({currency})`,
    TOTAL_REQUESTED: `Insgesamt angefordert`,
    TOTAL_REQUESTED_CLAIM_VALUE: `Gesamtantragswert (beantragt)`,
    TOTAL_UNPAID: `Gesamt unbezahlt`,
    TRACKING_NUMBER: `Tracking-Nummer`,
    TRANSFER: `Umlagerung`,
    TRANSFER_ALL: `Alle übertragen`,
    TRANSFER_APPROVALS: `Umlagerungsgenehmigung`,
    TRANSFER_APPROVALS_TAB: `Umlagerungsgenehmigungen ({count})`,
    TRANSFER_CREATED: `Umlagerung erstellt`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Vertriebspartnerempfehlungen übertragen`,
    TRANSFER_REJECTED: `Übertragung abgelehnt`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Transfer erfolgreich aktualisiert`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Alle Empfehlungen des Händlers übertragen`,
    TRANSFERS: `Umlagerungen`,
    TRAVEL: `Fahrt`,
    TURKISH: `Türkisch`,
    TWO_PERCENT_WITHHOLD_VALUE: `2% Wert halten`,
    TYPE: `Typ`,
    TYPES: `Typen`,
    UNABLE_TO_CONTACT_THE_SERVER: `Server nicht erreichbar`,
    UNABLE_TO_COPY_ATTACHMENTS: `Wir konnten keine Anhänge aus dem ursprünglichen Antrag kopieren. Bitte überprüfen Sie dies, bevor Sie Ihren neuen Antrag einreichen.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Herunterladen der Kundendaten nicht möglich`,
    UNDO: `Rückgängig`,
    UNDO_REGISTRATION: `Registrierung rückgängig machen`,
    UNDO_REGISTRATION_SUCCESSFULL: `Registrierung rückgängig machen ist erfolgreich`,
    UNIT: `Einheit`,
    UNIT_1: `Einheit 1`,
    UNIT_2: `Einheit 2`,
    UNIT_3: `Einheit 3`,
    UNIT_OF_MEASURE: `Maßeinheit`,
    UNPAID_LABOR: `Unbezahlte Arbeitszeit`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Unbezahlte Arbeitszeit-Zuschläge – mit Ausnahme von Produktverbesserungsprogrammen (PIPs)`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Unbezahlte Arbeitszeit-Zuschläge – Produktverbesserungsprogramme (PIPs)`,
    UNPAID_OTHER_CREDITS: `Unbezahlte sonstige Kosten`,
    UNPAID_PARTS: `Unbezahlte Teile`,
    UNPAID_PARTS_ADDITIVE: `Zuschläge für unbezahlte Teile`,
    UNPAID_TRAVEL: `Unbezahlte Fahrtkosten`,
    UNRECONCIL: `Unvereinbarkeit`,
    UNRECONCILE_CLAIM : `Antrag nicht abstimmen`,
    UNSUB: `Bearbeiten`,
    UNSUBMIT_CLAIM: `Bearbeiten Anfordern`,
    UPDATE: `Aktualisierung`,
    UPDATE_CUSTOMER_INFORMATION: `Kundenprofil aktualisieren`,
    UPDATE_LABOR_RATES: `Stundensatz aktualisieren`,
    UPDATE_LAYOUT: `Layout Aktualisieren`,
    UPDATE_MACHINE_STATUS: `Maschinenstatus aktualisieren`,
    UPDATE_MACHINE_STATUS_HISTORY: `Maschinenstatusverlauf aktualisieren`,
    UPDATE_REGISTRATION: `Registrierung aktualisieren`,
    UPDATE_SELECTED: `Auswahl aktualisieren`,
    UPDATED: `Aktualisiert`,
    UPDATED_BY: `Aktualisiert von`,
    UPDATED_DATE_FROM: `Von Aktualisierungsdatum`,
    UPDATED_DATE_TO: `Bis Aktualisierungsdatum`,
    UPLOAD_DOCUMENT: `Dokument hochladen`,
    UPTIME_ASSURANCE: `Betriebssicherheit`,
    USEFUL_LINKS: `Nützliche Links`,
    USER: `Benutzer`,
    USER_PREFERENCES_UPDATED: `Aktualisierte Benutzerpräferenzen`,
    USER_SELECTED: `Benutzer ausgewählt`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Vom Benutzer ausgewählte Anträge ({count})`,
    USERS_INFORMATION: `Benutzerinformationen`,
    VALIDATE: `Prüfen`,
    VALIDATE_CLAIM: `Antrag prüfen`,
    VALUE: `Wert`,
    VALUE_OF_REPAIR: `Reparaturwert`,
    VIEW_CLAIM: `Antrag anzeigen`,
    VIEW_DETAILS: `Details anzeigen`,
    VIEW_OPEN_PIPS: `Offene PIPs anzeigen`,
    VIEW_PIP: `PIP anzeigen`,
    VIEW_PRODUCTS: `Produkte anzeigen`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Produkte anzeigen und Infos aktualisieren`,
    VIEW_UPDATE: `Anzeigen/aktualisieren`,
    VSR_MESSAGES: `VSR-Meldungen`,
    WAITING_FOR_DLR_INV: `Warten auf Händlerrechnung`,
    WAITING_FOR_INVOICE: `Warten auf Rechnung ({count})`,
    WAITING_SINCE: `Warten seit`,
    WARNING_MESSAGE_TITLE: `Eine Warnung wurde gesendet:`,
    WARNING_MESSAGES: `Warnmeldungen`,
    WARNING_MESSAGES_TITLE: `Mehrere Warnungen wurden gesendet:`,
    WARRANTY: `Garantie`,
    WARRANTY_ADMIN: `Garantieverwaltung`,
    WARRANTY_CLAIM_TYPE: `Art des Gewährleistungsantrags`,
    WARRANTY_COVERAGE: `GWL Deckung`,
    WARRANTY_EXPIRATION: `Ablauf der Garantie`,
    WARRANTY_TYPE: `Garantietyp`,
    WARRANTY_TYPES: `Garantietypen`,
    WEAR_PARTS: `Verschleißteile`,
    WEAR_PARTS_COVERAGE: `Verschleißteildeckung`,
    WELCOME: `Willkommen`,
    WINTERIZATION: `Winterlagerung`,
    WIP: `Aktuelle Arbeit`,
    WITH_ADDITIVES: `Mit Zuschlägen`,
    WITNESS_FIRST_NAME: `Vorname des Zeugen`,
    WITNESS_LAST_NAME: `Nachname des Zeugen`,
    WORK_ORDER: `Reparaturauftrag`,
    WORK_ORDER_NUMBER: `Arbeitsauftragsnummer`,
    WORK_ORDER_ONE: `Referenznummer 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `Referenznummer 1 ist erforderlich`,
    WORK_ORDER_THREE: `Referenznummer 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `Arbeitsauftrag 3 ist erforderlich`,
    WORK_ORDER_TWO: `Referenznummer 2`,
    WORK_REPAIR_ORDER: `Arbeitsreparaturauftrag`,
    YES: `Ja`,
    YES_LOWERCASE: `Ja`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/de.js